import { Button } from '@mui/material'
import styled from 'styled-components'
import { BREAKPOINT_SM } from '../../theme/ota'

interface ContainerProps {
  status?: boolean
  bgColor?: string
}

export const Container = styled.div<ContainerProps>`
  width: 100%;
`

export type SelectPropsColor = {
  wide?: boolean | 'wide' | 'normal'
  bgColorButton?: string
  colorTextButton?: string
  highlighted?: boolean | any
}

export const Select = styled.select<SelectPropsColor>`
  border: 1px solid ${({ theme }) => theme.colors?.gray4};
  border-radius: 4px;
  color: ${({ theme }) => theme.colors?.black};
  cursor: pointer;
  font-size: 14px;
  line-height: 24px;
  padding: 6px;
  height: 36px;
  width: ${({ wide }) => (wide ? '100%' : '120px')};

  @media (max-width: calc(${BREAKPOINT_SM})) {
    display: none;
  }

  option {
    padding: 2px;
    &:hover {
      background-color: ${({ theme }) => theme.colors?.primary};
    }
  }
`

export const Btn = styled(Button).attrs<SelectPropsColor>(({ highlighted = false }) => ({
  variant: highlighted ? 'contained' : 'outlined',
  color: highlighted ? 'primary' : 'textColor',
}))<SelectPropsColor>`
  display: flex;
  align-items: center;
  justify-content: baseline;
  gap: 10px;
  @media (max-width: calc(${BREAKPOINT_SM})) {
    &&& {
      height: 56px;
      max-height: 56px;
      font-size: 16px;
    }
  }
  &&& {
    min-width: 113px;
    width: ${({ wide }) => (wide ? '100%' : '113px')};
    font-size: 14px;
    font-weight: 700;
  }

  div {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`

export const Mobile = styled.div`
  width: 100%;
  height: 56px;
  display: flex;
  padding: 10px 15px;
  border-radius: 4px;
  align-items: center;
  background-color: #e4eefe;
  justify-content: space-between;

  @media (min-width: calc(${BREAKPOINT_SM})) {
    display: none;
  }
`

export const NumberOfRoomsText = styled.p`
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0%;
  line-height: 19.12px;
  text-transform: uppercase;

  color: ${({ theme }) => theme?.colors?.textColor};
`

export const Desktop = styled.div`
  @media (max-width: calc(${BREAKPOINT_SM})) {
    display: none;
  }
`
